const XML = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M19.4 2.01a2 2 0 0 1 1.796 1.989v16.003l-.01.204A2 2 0 0 1 19.4 21.99l-.204.01H6.209l-.204-.01a2 2 0 0 1-1.785-1.785l-.01-.204V17.95H2.936v-7.01h1.272V3.999a2 2 0 0 1 1.796-1.99L6.21 2h12.987l.204.01ZM6.21 3.498a.5.5 0 0 0-.5.5v6.942h10.766v7.01H5.71V20a.5.5 0 0 0 .5.5h12.987a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H6.209ZM6.801 14.4l-.856 1.478h.624l.544-.938.544.938h.628l-.86-1.482.812-1.4h-.624l-.5.864-.5-.864H5.99l.812 1.404Zm1.793 1.478h.552v-1.865l.788 1.334H10l.788-1.339v1.87h.547v-2.882h-.568l-.8 1.363-.803-1.363h-.569v2.882Zm3.262 0h1.62v-.544H12.41v-2.338h-.552v2.882Z"
        />
    </svg>
);

export default XML;
